var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasModule
    ? _c(
        "w-card",
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("payment-terminal-settings"))),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-radio", {
                        attrs: {
                          label: _vm.$ct("ctep-disabled"),
                          checked: _vm.disabled,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setModeDisabled()
                          },
                        },
                      }),
                      _c("w-radio", {
                        attrs: {
                          label: _vm.$ct("ctep-via-cloud"),
                          checked: _vm.isCloudMode,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setCloudMode()
                          },
                        },
                      }),
                      _c("w-radio", {
                        attrs: {
                          disabled: !_vm.isElectron,
                          label: _vm.$ct("ctep-serial"),
                          checked: _vm.isSerialMode,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setSerialMode()
                          },
                        },
                      }),
                      _c("w-radio", {
                        attrs: {
                          disabled: !_vm.isElectron,
                          label: _vm.$ct("ctep-tcp"),
                          checked: _vm.isTcpMode,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setTcpMode()
                          },
                        },
                      }),
                      _c("w-radio", {
                        attrs: {
                          disabled: !_vm.isElectron,
                          label: _vm.$ct("ctep-connect"),
                          checked: _vm.isConnectMode,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setConnectMode()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.isSerialMode
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.serialPortItems,
                              label: _vm.$ct("ctep-serial-port"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.settings.comPort,
                              callback: function ($$v) {
                                _vm.$set(_vm.settings, "comPort", $$v)
                              },
                              expression: "settings.comPort",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm.isTcpMode
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 0,
                              min: 0,
                              label: _vm.$ct("ctep-tcp-port"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.settings.port,
                              callback: function ($$v) {
                                _vm.$set(_vm.settings, "port", $$v)
                              },
                              expression: "settings.port",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm.isConnectMode
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: {
                              label: _vm.$ct("ctep-connect-url"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.settings.connectUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.settings, "connectUrl", $$v)
                              },
                              expression: "settings.connectUrl",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm.isCloudMode
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-ctep-terminal-select", {
                            attrs: {
                              label: _vm.$ct("default-terminal"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.settings.defaultTerminalId,
                              callback: function ($$v) {
                                _vm.$set(_vm.settings, "defaultTerminalId", $$v)
                              },
                              expression: "settings.defaultTerminalId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-col",
                    [
                      _c("app-select-bank-type", {
                        attrs: {
                          "use-ids": "",
                          fancy: "",
                          label: _vm.$ct("default-bank"),
                          disabled: _vm.disabled,
                        },
                        model: {
                          value: _vm.settings.defaultBankId,
                          callback: function ($$v) {
                            _vm.$set(_vm.settings, "defaultBankId", $$v)
                          },
                          expression: "settings.defaultBankId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _vm.showSelfCertificationButton
                        ? _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("ctep-self-certification"),
                              disabled: _vm.disabled,
                            },
                            model: {
                              value: _vm.settings.selfCertificationModeEnabled,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "selfCertificationModeEnabled",
                                  $$v
                                )
                              },
                              expression:
                                "settings.selfCertificationModeEnabled",
                            },
                          })
                        : _vm._e(),
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("ctep-auto-send-ticket"),
                          disabled: _vm.disabled,
                        },
                        model: {
                          value: _vm.settings.openSendTicketAfterPaid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.settings,
                              "openSendTicketAfterPaid",
                              $$v
                            )
                          },
                          expression: "settings.openSendTicketAfterPaid",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: _vm.saving, icon: "save" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.save")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }